// extracted by mini-css-extract-plugin
export default {"container":"Header_container__lPHyv","left":"Header_left__LaiGd","right":"Header_right__8FEhL","item":"Header_item__uPbRI","center":"Header_center__Ii5tr"};